
import dust from "dustjs-linkedin";


(function(){dust.register("grammar-tips/no-results",body_0);function body_0(chk,ctx){return chk.write("<section class=\"no-results\"><div class=\"huge-magnifying-glass\"></div><h3>").helper("i18n",ctx,{},{"id":"grammar_tips_no_results_heading"}).write("</h3><p class=\"subheading\">").helper("i18n",ctx,{},{"id":"grammar_tips_no_results_subheading"}).write("</p></section>");}return body_0;})();

export default 0;
